import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { httpApps } from "../../helper/http-common";

const TrackingHandler = ({ appType }) => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("Processing...");
  const [error, setError] = useState(null);

  // Define which endpoints use GET vs POST
  const getEndpoints = [
    "diamond",
    "ringbuilder-product",
    "ringbuilder-activity",
    "masterlink-diamond",
    "masterlink-ringbuilder-product"
  ];

  useEffect(() => {
    const trackView = async () => {
      try {
        // Get all URL parameters
        const params = Object.fromEntries(searchParams.entries());

        // Determine API endpoint based on app type
        let endpoint = "";

        switch (appType) {
          // DiamondLink Tracking
          case "diamond":
            endpoint = "/DiamondLink/DiamondTracking";
            break;
          case "diamond-product":
            endpoint = "/DiamondLink/ProductTracking";
            break;
          case "diamond-pair":
            endpoint = "/DiamondLink/DiamondTracking_Pair";
            break;
          // RingBuilder Tracking
          case "ringbuilder-product":
            endpoint = "/RingBuilder/ProductTracking";
            break;
          case "ringbuilder-activity":
            endpoint = "/RingBuilder/ActivityTracking";
            break;
          // MasterLink Tracking (DiamondLinkForML)
          case "masterlink-diamond":
            endpoint = "/DiamondLinkForML/DiamondTracking";
            break;
          case "masterlink-product":
            endpoint = "/DiamondLinkForML/ProductTracking";
            break;
          case "masterlink-diamond-pair":
            endpoint = "/DiamondLinkForML/DiamondTracking_Pair";
            break;
          // MasterLink Tracking (RingBuilderForML)
          case "masterlink-ringbuilder-product":
            endpoint = "/RingBuilderForML/ProductTracking";
            break;
          default:
            endpoint = "/DiamondLink/DiamondTracking";
        }

        let response;
        const isGetEndpoint = getEndpoints.includes(appType);

        if (isGetEndpoint) {
          // GET request - params in URL
          const queryString = new URLSearchParams(params).toString();
          const fullUrl = `${endpoint}?${queryString}`;
          console.log("Tracking API Call (GET):", fullUrl);
          response = await httpApps.get(fullUrl);
        } else {
          // POST request - try GET first, if 405 then POST
          const queryString = new URLSearchParams(params).toString();
          const fullUrl = `${endpoint}?${queryString}`;

          try {
            console.log("Tracking API Call (GET attempt):", fullUrl);
            response = await httpApps.get(fullUrl);
          } catch (getError) {
            // If GET fails with 405 (Method Not Allowed), try POST
            if (getError.response && getError.response.status === 405) {
              console.log("GET failed, trying POST:", endpoint);
              response = await httpApps.post(endpoint, params);
            } else {
              throw getError;
            }
          }
        }

        if (response.status === 200) {
          setStatus("Tracking recorded successfully");
          console.log("Tracking response:", response.data);
        } else {
          setStatus("Tracking completed");
        }
      } catch (err) {
        console.error("Tracking error:", err);
        setError(err.message);
        setStatus("Error occurred");
      }
    };

    // Only track if we have parameters
    if (searchParams.toString()) {
      trackView();
    } else {
      setStatus("No tracking parameters provided");
    }
  }, [searchParams, appType]);

  // Return minimal response (can be customized)
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      fontFamily: "Arial, sans-serif"
    }}>
      <div style={{ textAlign: "center" }}>
        <p>{status}</p>
        {error && <p style={{ color: "red" }}>Error: {error}</p>}
      </div>
    </div>
  );
};

export default TrackingHandler;
